/*document.addEventListener('DOMContentLoaded', () => {
  const tabWrapper = document.querySelector(".faq-tab-wrapper");
  
  if (tabWrapper) {
      const tabBtns = document.querySelectorAll(".faq-tab-nav [data-tab-target]");
      const tabTargets = document.querySelectorAll(".tab-target");
  
      tabWrapper.addEventListener("click", (e) => {
          if (e.target.tagName.toLowerCase() !== "a") {
              e.preventDefault();
          }
  
          const id = e.target.dataset.tabTarget;
          
          if (id) {
              // Update active button
              tabBtns.forEach(btn => btn.classList.remove("is-active"));
              e.target.classList.add("is-active");
              
              // Update active content
              tabTargets.forEach(content => content.classList.remove("is-active"));
              document.getElementById(id).classList.add("is-active");
          }
      });
  }
});*/

document.addEventListener('DOMContentLoaded', () => {
  // Select all faq-tab-wrapper elements
  const tabWrappers = document.querySelectorAll(".faq-tab-wrapper");

  tabWrappers.forEach(wrapper => {
    const tabBtns = wrapper.querySelectorAll(".faq-tab-nav [data-tab-target]");
    const tabTargets = wrapper.querySelectorAll(".tab-target");

    wrapper.addEventListener("click", (e) => {
      const target = e.target.closest("[data-tab-target]");
      if (!target) return;

      e.preventDefault();

      const id = target.dataset.tabTarget;
      if (!id) return;

      // Update active button
      tabBtns.forEach(btn => btn.classList.remove("is-active"));
      target.classList.add("is-active");

      // Update active content
      tabTargets.forEach(content => content.classList.remove("is-active"));
      const targetContent = wrapper.querySelector(`#${id}`);
      if (targetContent) {
        targetContent.classList.add("is-active");
      }
    });
  });

  const triggers = document.querySelectorAll('.collapsible-trigger');
    
  triggers.forEach(trigger => {
      
      const targetId = trigger.getAttribute('aria-controls');
      const content = document.getElementById(targetId);
      
      if (content) {
        // Initialize
        content.style.height = '0px';
        
        trigger.addEventListener('click', () => {
          console.log('trigger ',trigger);
          // Toggle the is-open class
          trigger.classList.toggle('is-open');
          content.classList.toggle('is-open');
          
          // Update aria-expanded
          const isExpanded = trigger.classList.contains('is-open');
          trigger.setAttribute('aria-expanded', isExpanded);
          
          if (isExpanded) {
            // Calculate full height when opening
            content.style.height = 'auto';
            const fullHeight = content.scrollHeight + 'px';
            content.style.height = '0px';
            
            // Trigger transition after a small delay
            setTimeout(() => {
              content.style.height = fullHeight;
            }, 10);
          } else {
            // Collapse
            content.style.height = '0px';
          }
        });
        
        // Handle window resizing
        let resizeTimer;
        window.addEventListener('resize', () => {
          if (trigger.classList.contains('is-open')) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
              content.style.height = 'auto';
              const fullHeight = content.scrollHeight + 'px';
              content.style.height = fullHeight;
            }, 250);
          }
        });
      }
    });
  
});

